import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import RetailerApprovalTable from '../../../components/tables/RetailerApprovalTable';

const RetailerApproval = () => {
  // Sample data generator for retailer approvals
  const generateSampleData = () => {
    const cities = ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad'];
    const names = [
      'Rajesh Kumar', 'Priya Sharma', 'Amit Patel', 'Sneha Reddy',
      'Vikram Singh', 'Anjali Gupta', 'Rahul Verma', 'Neha Joshi',
      'Suresh Yadav', 'Kavita Mehta', 'Arun Kumar', 'Pooja Singh',
      'Deepak Sharma', 'Ritu Agarwal', 'Manoj Tiwari', 'Swati Desai',
      'Sanjay Rao', 'Meera Nair', 'Karan Khanna', 'Divya Saxena'
    ];

    return Array.from({ length: 30 }, (_, i) => {
      const requestDate = new Date(
        2024,
        Math.floor(Math.random() * 12),
        Math.floor(Math.random() * 28) + 1
      );

      return {
        id: `RET${String(i + 1).padStart(5, '0')}`,
        name: names[Math.floor(Math.random() * names.length)],
        email: `retailer${i + 1}@example.com`,
        phone: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
        city: cities[Math.floor(Math.random() * cities.length)],
        requestDate: requestDate.toISOString().split('T')[0],
        status: 'Pending',
        actionDate: null
      };
    });
  };

  // Initialize data with state
  const [retailersData] = useState(generateSampleData());

  return (
    <Container fluid className="">
      <RetailerApprovalTable
        data={retailersData}
      />
    </Container>
  );
};

export default RetailerApproval;

